<template>
	<div>
		<div class="sense-main">
			<div class="sense-search sense-search-c2d" style="padding-bottom: 22px;">
				<el-row>
					<el-form :inline="true" label-width="68px">
						<el-select size="medium" v-model="type" style="width: 100px;" @change="selectChange">
							<el-option label="C2D" value="1"></el-option>
							<el-option label="D2C" value="2"></el-option>
						</el-select>
						
						<el-upload
							v-show="type == '1'"
							class="upload" 
							ref="uploadC2D"
							action="/uploadC2D.do"
							name="data"
							:multiple="false"
							:show-file-list="false"
							:auto-upload="false"
							:on-change="uploadC2DChange"
							:on-success="uploadC2DSuccess">
							<el-input slot="trigger" size="medium" placeholder="点击选择C2D文件" v-model="fileNameC2D" maxlength="64" readonly></el-input>
						</el-upload>
						<el-button v-show="type == '1'" class="search-btn" size="medium" type="primary" @click="searchLicenseC2D" style="margin-left: 20px; top: 0px;">搜索</el-button>	

						<el-upload
							v-show="type == '2'"
							class="upload" 
							ref="uploadD2C"
							action="/uploadD2C.do"
							name="data"
							:multiple="false"
							:show-file-list="false"
							:auto-upload="false"
							:on-change="uploadD2CChange"
							:on-success="uploadD2CSuccess">
							<el-input slot="trigger" size="medium" placeholder="点击选择D2C文件" v-model="fileNameD2C" maxlength="64" readonly></el-input>
						</el-upload>
						<el-button v-show="type == '2'" class="search-btn" size="medium" type="primary" @click="searchLicenseD2C" style="margin-left: 20px; top: 0px;">搜索</el-button>	
					</el-form>
				</el-row>
			</div>
			<el-tabs type="border-card" v-model="tabsActive" v-show="type == '1'">
				<el-tab-pane label="账号许可" name="1">
					<div class="sense-table-list sense-table-ellipsis">
						<el-table :data="licenseListData">					
							<el-table-column prop="account" label="账号" min-width="12%" show-overflow-tooltip></el-table-column>
							<el-table-column prop="userName" label="用户名称" min-width="8%" show-overflow-tooltip></el-table-column>
							<el-table-column prop="templateName" label="模板名称" min-width="11%" show-overflow-tooltip></el-table-column>					
							<el-table-column prop="productName" label="产品名称" min-width="11%" show-overflow-tooltip></el-table-column>
							<el-table-column prop="licenseId" label="许可ID" min-width="8%" show-overflow-tooltip></el-table-column>
							<el-table-column :formatter="isForeverFormatter" label="是否永久" min-width="7%"></el-table-column>
							<el-table-column prop="startTime" label="许可开始时间" min-width="12%" show-overflow-tooltip></el-table-column>
							<el-table-column prop="endTime" label="许可结束时间" min-width="12%" show-overflow-tooltip></el-table-column>
							<el-table-column prop="createTime" label="签发时间" min-width="12%" show-overflow-tooltip></el-table-column>
							<el-table-column :formatter="licenseFormFormatter" label="许可形式" min-width="7%"></el-table-column>			
						</el-table>
					</div>
				</el-tab-pane>
				<el-tab-pane label="授权码许可" name="2">
					<div class="sense-table-list sense-table-ellipsis" v-if="tabsActive == '2'">
						<el-table :data="snLicenseListData">					
							<el-table-column prop="sn" label="授权码" min-width="18%" show-overflow-tooltip></el-table-column>
							<el-table-column prop="templateName" label="授权码模板" min-width="14%" show-overflow-tooltip></el-table-column>
							<el-table-column prop="userName" label="用户名称" min-width="13%" show-overflow-tooltip></el-table-column>					
							<el-table-column :formatter="contactTypeFormatter" label="联系方式" min-width="16%" show-overflow-tooltip></el-table-column>
							<el-table-column label="系统平台" min-width="8%">
								<template slot-scope="scope">
									<em v-if="scope.row.platform == 7" title="Windows" class="ssicon ss-windows"></em>
									<em v-if="scope.row.platform == 7" title="Linux" class="ssicon ss-linux"></em>
									<em v-if="scope.row.platform == 7" title="Mac" class="ssicon ss-mac"></em>
									<em v-if="(scope.row.platform & 24) > 0" title="Android" class="ssicon ss-android"></em>
									<em v-if="(scope.row.platform & 24) > 0" title="ARM Linux" class="arm-linux-icon"></em>
								</template>
							</el-table-column>
							<el-table-column prop="createAt" label="签发时间" min-width="15%"></el-table-column>
							<el-table-column prop="exchangeAt" label="绑定时间" min-width="15%"></el-table-column>			
						</el-table>
					</div>
				</el-tab-pane>
			</el-tabs>
			<div class="sense-table-list sense-table-ellipsis sense-detail" v-show="type == '2'">
				<div class="sense-detail-block" v-if="LicenseObj.resultType == 2">
					<el-form label-width="130px">
						<el-row>
							<el-col :span="12">
								<el-form-item label="授权码：">
									<div class="sense-text">{{ LicenseObj.licenseKey }}</div>
								</el-form-item>		
							</el-col>
							<el-col :span="12">
								<el-form-item label="系统平台：">
									<div class="sense-text" v-if="LicenseObj.platform == 7" style="position: relative;top: -2px;">
										传统 (
										<em title="Windows" class="ssicon ss-windows"></em>
										<em title="Linux" class="ssicon ss-linux"></em>
										<em title="Mac" class="ssicon ss-mac"></em>
										)
									</div>
									<div class="sense-text" v-if="(LicenseObj.platform & 24) > 0" style="position: relative;top: -2px;">
										智能(
										<em title="Android" class="ssicon ss-android"></em>
										<em title="ARM Linux" class="arm-linux-icon"></em>
										)
									</div>	
								</el-form-item>		
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item label="终端ID：">
									<div class="sense-text sense-ellipsis" :title="LicenseObj.machineId">{{ LicenseObj.machineId }}</div>
								</el-form-item>		
							</el-col>
							<el-col :span="12">
								<el-form-item label="终端名称：">
									<div class="sense-text">{{ LicenseObj.terminalName }}</div>
								</el-form-item>		
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item label="是否永久：">
									<div class="sense-text">{{ LicenseObj.isForever | isForeverFilter }}</div>
								</el-form-item>		
							</el-col>
							<el-col :span="12">
								<el-form-item label="开始时间：">
									<div class="sense-text">{{ LicenseObj.startTime | commonFilter }}</div>
								</el-form-item>		
							</el-col>
						</el-row>	
						<el-row>
							<el-col :span="12">
								<el-form-item label="时间跨度：">
									<div class="sense-text">{{ LicenseObj.spanTime | commonFilter }}</div>
								</el-form-item>		
							</el-col>
							<el-col :span="12">
								<el-form-item label="结束时间：">
									<div class="sense-text">{{ LicenseObj.endTime | commonFilter }}</div>
								</el-form-item>		
							</el-col>
						</el-row>	
						<el-row>
							<el-col :span="12" v-if="LicenseObj.platform == 7">
								<el-form-item label="许可类型：">
									<div class="sense-text">{{ LicenseObj.hasConcurrent | concurrentFilter(LicenseObj.concurrentType, LicenseObj.concurrent) }}</div>
								</el-form-item>		
							</el-col>
							<el-col :span="12" v-if="LicenseObj.hasConcurrent != true">
								<el-form-item label="同时绑定设备数：">
									<div class="sense-text">{{ LicenseObj.bindLimit }}</div>
								</el-form-item>		
							</el-col>
							<el-col :span="12" v-if="LicenseObj.platform == 7 && LicenseObj.hasConcurrent != true">
								<el-form-item label="累积绑定设备数：">
									<div class="sense-text">{{ LicenseObj.bindMaxLimit | bindMaxLimitFilter }}</div>
								</el-form-item>		
							</el-col>
						</el-row>						
					</el-form>	
				</div>
				<div class="sense-detail-block" v-if="LicenseObj.resultType == 3">
					<el-form label-width="110px">
						<el-row>	
							<el-col :span="12">
								<el-form-item label="外壳号：">
									<div class="sense-text sense-ellipsis" :title="LicenseObj.shellNumber">{{ LicenseObj.shellNumber }}</div>
								</el-form-item>		
							</el-col>
							<el-col :span="12">
								<el-form-item label="序列号：">
									<div class="sense-text">{{ LicenseObj.dongleId }}</div>
								</el-form-item>		
							</el-col>
						</el-row>						
					</el-form>	
				</div>
			</div>
		</div>
		<div class="all-dialog">
			
		</div>
	</div>
</template>

<script>
	import { ajax } from '../api/api.js'

	export default {
		data() {
			return {
				fileNameC2D: '',
				fileNameD2C: '',				
				licenseListData: [],  //账号许可列表数组
				snLicenseListData: [],  //授权码许可列表数组
				LicenseObj: {},
				type: '1',	
				tabsActive: '1',
			}
		},
		filters: {
			//是否永久filter
			isForeverFilter: function(val) {
				if (val == 1) {
					return '永久';
				} else {
					return '非永久';
				};
			},
			//common filter
			commonFilter: function(val) {
				if (!val) {
					return '--';
				} else {
					return val;
				};
			},
			//累积绑定设备数filter
			bindMaxLimitFilter: function(val) {
				if (val === 0) {
					return '不限制';
				} else {
					return val;
				};
			},
			//并发方式filter
			concurrentFilter: function(hasConcurrent, concurrentType, concurrent) {
				if (hasConcurrent == false) {
					return '单机许可';
				} else {
					var concurrentTypeName = concurrentType=='process'?'进程':'会话';
					return '集团许可 ' + concurrentTypeName + '(用户数: ' + concurrent + ')';
				};
			},
		},
		methods: {
			//是否永久formatter
			isForeverFormatter(row, index) {
				if (row.isForever == 1) {
					return '永久';
				} else {
					return '非永久';
				};
			},
			//许可形式formatter
			licenseFormFormatter(row, index) {
				if (row.licenseForm == 1) {
					return '云锁';
				} else {
					return '软锁';
				};
			},
			//联系方式formatter
			contactTypeFormatter(row, index) {
				if (row.phone && !row.email) {
					return row.phone;
				} else if (!row.phone && row.email) {
					return row.email;
				} else if (row.phone && row.email) {
					return row.phone + ' / ' + row.email;
				} else {
					return '';
				};
			},
			//C2D/D2C切换
			selectChange() {
				this.licenseListData = [];
				this.snLicenseListData = [];
				this.LicenseObj = {};
				this.fileNameC2D = '';
				this.fileNameD2C = '';
				this.tabsActive = '1';
			},
			//C2D搜索
			searchLicenseC2D() {
				if (!this.fileNameC2D) {
					this.$message({
						message: '请选择C2D文件',
						type: 'warning'
					});
				} else {					
					this.$refs.uploadC2D.submit();
				};
			},
			//D2C搜索
			searchLicenseD2C() {
				if (!this.fileNameD2C) {
					this.$message({
						message: '请选择D2C文件',
						type: 'warning'
					});
				} else {
					this.$refs.uploadD2C.submit();
				};
			},
			//C2D文件上传成功	
			uploadC2DSuccess(response, file, fileList) {
				if (response.code == 0) {
					if (response.data.licenses.length == 0 && response.data.licenseKey.length > 0) {
						this.tabsActive = '2';
					};
					this.licenseListData = response.data.licenses;
					this.snLicenseListData = response.data.licenseKey;
				} else {
					this.$nextTick(function() {
						this.fileNameC2D = '';
						this.$refs.uploadC2D.clearFiles();
					});
					this.licenseListData = [];
					this.snLicenseListData = [];
					
					this.$message({
						message: response.desc,
						type: 'warning'
					});
				};				
			},
			//D2C文件上传成功	
			uploadD2CSuccess(response, file, fileList) {
				if (response.code == 0) {
					this.LicenseObj = response.data;
				} else {
					this.$nextTick(function() {
						this.fileNameD2C = '';
						this.$refs.uploadD2C.clearFiles();
					});
					this.LicenseObj = {};
					
					this.$message({
						message: response.desc,
						type: 'warning'
					});
				};				
			},
			//C2D文件change
			uploadC2DChange(file, fileList) {
				this.fileNameC2D = file.name;
			},
			//D2C文件change
			uploadD2CChange(file, fileList) {
				this.fileNameD2C = file.name;
			},
		},
		mounted() {
			
		},
	}
</script>

<style scoped lang="scss">	

</style>


// WEBPACK FOOTER //
// SearchLicense.vue?57c8ef1a